import type * as Types from '../../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlDashboardQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  fileFilter?: Types.InputMaybe<Types.GqlFileFilterInput>;
}>;


export type GqlDashboardQuery = { currentUser: { createdAt: string, id: string }, snrShareCapitalChanges: Array<{ registrationDate: string, shareValueSplitAdjusted?: string | null, sharesTotalSplitAdjusted?: string | null, name: string, id: string, currency: Types.GqlCurrency }>, investments: Array<{ kind: string, id: string, name?: string | null, decisionStatus: Types.GqlDecisionStatus, registrationStatus: Types.GqlRegistrationStatus, lastSubDate?: string | null, agreementStatus: Types.GqlAgreementStatus, description: string }>, warrantPrograms: { models: Array<{ id: string, usesStepper: boolean, name?: string | null, warrantKind: Types.GqlWarrantProgramKind, warrantStartDate?: string | null, agreementStatus: Types.GqlAgreementStatus, decisionStatus: Types.GqlDecisionStatus, registrationStatus: Types.GqlRegistrationStatus, warrantEndDate?: string | null, description: string }> }, company: { id: string, name: string, email?: string | null, foundationDate: string, addressAsStr?: string | null, authorizedSignatory: string, shareholderMeetingHowtoCall: string, fiscalYear: Types.GqlFiscalYear, shareRegisterShareCount: number }, meetings: { models: Array<{ id: string, companyId: string, kind: Types.GqlMeetingKind, number?: string | null, startTime: string, summonStatus: Types.GqlMeetingSummonStatus, agendaItemsDone: boolean, latestMinutesDocument?: { id: string, scriveStatus?: Types.GqlScriveDocumentStatus | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null } | null }> }, snrCases: { totalCount: number, models: Array<{ id: string, arrivalDate?: string | null, registrationDate?: string | null, subjects: Array<{ value: string }>, status: Array<{ kod: string, value: string }> }> }, file: { children: { models: Array<{ id: string, filename: string, scriveStatus?: Types.GqlScriveDocumentStatus | null, zignedAgreementStatus?: Types.GqlZignedAgreementStatus | null, createdAt: string, signatureMethod?: Types.GqlDocumentSignatureMethod | null }> } }, shareholders: Array<{ id: string, shareState?: { numberOfShares: number } | null, identity: { id: string, name: string } }> };


export const DashboardDocument = gql`
    query Dashboard($companyId: ID!, $fileFilter: FileFilterInput) {
  currentUser {
    createdAt
    id
  }
  snrShareCapitalChanges(
    companyId: $companyId
    filter: {sort: ASC, names: [NYBILDNING, NYEMISSION], excludeAtQuotaValue: true}
  ) {
    registrationDate
    shareValueSplitAdjusted
    sharesTotalSplitAdjusted
    name
    id
    currency
  }
  investments(companyId: $companyId) {
    kind
    id
    name
    decisionStatus
    registrationStatus
    lastSubDate
    agreementStatus
    description
  }
  warrantPrograms(companyId: $companyId, kinds: [Warrant], limit: 5) {
    models {
      id
      usesStepper
      name
      warrantKind
      warrantStartDate
      agreementStatus
      decisionStatus
      registrationStatus
      warrantEndDate
      description
    }
  }
  company(id: $companyId) {
    id
    name
    email
    foundationDate
    addressAsStr
    authorizedSignatory
    shareholderMeetingHowtoCall
    fiscalYear
    shareRegisterShareCount
  }
  meetings(
    companyId: $companyId
    limit: 5
    sortField: "createdAt"
    sortDirection: DESC
  ) {
    models {
      id
      companyId
      kind
      number
      startTime
      summonStatus
      agendaItemsDone
      latestMinutesDocument {
        id
        scriveStatus
        zignedAgreementStatus
      }
    }
  }
  snrCases(companyId: $companyId, limit: 5) {
    models {
      id
      subjects {
        value
      }
      status {
        kod
        value
      }
      arrivalDate
      registrationDate
    }
    totalCount
  }
  file(companyId: $companyId) {
    children(offset: 0, limit: 5, filter: $fileFilter, lang: "sv") {
      models {
        id
        filename
        scriveStatus
        zignedAgreementStatus
        createdAt
        signatureMethod
      }
    }
  }
  shareholders(companyId: $companyId, limit: 5) {
    id
    shareState {
      numberOfShares
    }
    identity {
      id
      name
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      fileFilter: // value for 'fileFilter'
 *   },
 * });
 */
export function useDashboardQuery(baseOptions: Apollo.QueryHookOptions<GqlDashboardQuery, GqlDashboardQueryVariables> & ({ variables: GqlDashboardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlDashboardQuery, GqlDashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlDashboardQuery, GqlDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlDashboardQuery, GqlDashboardQueryVariables>(DashboardDocument, options);
        }
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlDashboardQuery, GqlDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlDashboardQuery, GqlDashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardSuspenseQueryHookResult = ReturnType<typeof useDashboardSuspenseQuery>;
export type DashboardQueryResult = Apollo.QueryResult<GqlDashboardQuery, GqlDashboardQueryVariables>;